(() => {
    "use strict";

    /**
     * Fachada do player do YouTube: a página mostra a miniatura com o botão de play e o iframe só é criado no clique
     * (com autoplay). Antes o iframe entrava com a página e trazia ~2 MB de JavaScript do YouTube junto.
     * Delegado no documento para funcionar também depois da navegação parcial (page-nav).
     */
    document.addEventListener("click", (event) => {
        const button = event.target.closest("[data-youtube-play]");
        if (!button) {
            return;
        }
        event.preventDefault();
        const player = button.closest(".temas-video-player");
        const src = button.getAttribute("data-youtube-play") || "";
        if (!player || !/^https:\/\/www\.youtube(-nocookie)?\.com\/embed\//.test(src)) {
            return;
        }

        const iframe = document.createElement("iframe");
        iframe.className = "temas-video-iframe";
        iframe.src = src + (src.includes("?") ? "&" : "?") + "autoplay=1";
        iframe.title = button.getAttribute("data-youtube-title") || "Vídeo";
        iframe.width = 560;
        iframe.height = 315;
        iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
        iframe.referrerPolicy = "strict-origin-when-cross-origin";
        iframe.allowFullscreen = true;
        player.appendChild(iframe);
        player.classList.add("is-playing");
        iframe.focus();
    });
})();
